import React from 'react';
import { connect } from 'react-redux';
import QRCode from "qrcode.react";
import { Modal } from "antd";
import I18, { i18Get } from '../../i18';
import { SetVerifyModalWindow } from '../../actions/ui';



const AccountVerification = ({
  window,
  assessments,
  dispatch
}) => {
  const onClose = () => {
    dispatch(SetVerifyModalWindow('QR'));
  };

  const retryVerification = () => {
    dispatch(SetVerifyModalWindow('QR_CODE'));
  };

  const verification_Modal = () => {
    return (
      <Modal
        visible={window === 'QR_CODE'}
        footer={null}
        onCancel={onClose}
        closable={true}
        centered
        bodyStyle={{
          padding: "20px",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            position: "relative",
            borderRadius: "28px",
            overflow: "hidden",
            padding: "20px",
            background: "#fff",
          }}
        >
          <h2
            style={{
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            {i18Get('Verify Your Account')}
          </h2>

          <p
            style={{
              fontSize: "18px",
              marginBottom: "20px",
              lineHeight: "22px",
              color: "black",
            }}
          >
            {i18Get(
              'Please use the CANKADO Patient App to scan the QR code and complete your account verification'
            )}
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <QRCode
            value={assessments?.assUuid || ''}
            size={300}
          />
          </div>
        </div>
      </Modal>
    );
  };

  const verification_fail = () => {
    return (
      <Modal
        visible={window === 'QR_CODE_FAIL'}
        footer={null}
        onCancel={onClose}
        closable={true}
        centered
        width={420}
        bodyStyle={{
          padding: "20px",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            borderRadius: "28px",
            overflow: "hidden",
            padding: "20px",
            background: "#fff",
          }}
        >
          <h2
            style={{
              fontWeight: "700",
              fontSize: "22px",
              marginBottom: "30px",
              color: "#111",
            }}
          >
            {i18Get('Verify Your Account')}
          </h2>

          <img
            src="/images/accfail.png"
            alt="fail"
            style={{
              width: "120px",
              marginBottom: "25px",
            }}
          />

          <h3
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#111",
              lineHeight: "32px",
              marginBottom: "30px",
            }}
          >
            {i18Get('User Account')}
            <br />
            {i18Get('Verification Failed')}
          </h3>

          <button
            onClick={retryVerification}
            style={{
              width: "100%",
              height: "48px",
              background: "#3C9B7B",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
              marginBottom: "16px",
            }}
          >
            {i18Get('Retry')}
          </button>

          <button
            onClick={onClose}
            style={{
              width: "100%",
              height: "48px",
              background: "#A7B4AF",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            {i18Get('Go back to questionnaire')}
          </button>
        </div>
      </Modal>
    );
  };

  const verification_success = () => {
    return (
      <Modal
        visible={window === 'QR_CODE_SUCCESS'}
        footer={null}
        onCancel={onClose}
        closable={false}
        centered
        width={420}
        bodyStyle={{
          padding: "20px",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            borderRadius: "28px",
            overflow: "hidden",
            padding: "20px",
            background: "#fff",
          }}
        >
          <h2
            style={{
              fontWeight: "700",
              fontSize: "22px",
              marginBottom: "40px",
              color: "#111",
            }}
          >
            {i18Get('Verify Your Account')}
          </h2>

          <img
            src="/images/succssimg.png"
            alt="success"
            style={{
              width: "120px",
              marginBottom: "30px",
            }}
          />

          <h3
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#111",
              lineHeight: "32px",
              marginBottom: "35px",
            }}
          >
            {i18Get('User Account Verified')}
            <br />
            {i18Get('successfully')}
          </h3>

          <button
            onClick={onClose}
            style={{
              width: "100%",
              height: "48px",
              background: "#3C9B7B",
              border: "none",
              borderRadius: "6px",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            {i18Get('Go back to questionnaire')}
          </button>
        </div>
      </Modal>
    );
  };

  return (
    <>
      {window === 'QR_CODE' && verification_Modal()}
      {window === 'QR_CODE_FAIL' && verification_fail()}
      {window === 'QR_CODE_SUCCESS' && verification_success()}
    </>
  );
};

export default connect()(AccountVerification);